import { render, staticRenderFns } from "./UserBanModal.vue?vue&type=template&id=57497a86"
import script from "./UserBanModal.vue?vue&type=script&lang=js"
export * from "./UserBanModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports